export default "__VITE_ASSET__BHzEQEfE__"